module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--terms"
  }, [_c(_vm.privacyContent, {
    tag: "component",
    staticClass: "group group--indent typeset typeset--terms links"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-593992b6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/Privacy.vue
// module id = 440
// module chunks = 0